import './Skeleton.css';

function Skeleton({ width = '100%', height = 16, radius, circle = false, className = '', style = {} }) {
  return (
    <span
      className={`ds-skeleton ${className}`.trim()}
      style={{
        width,
        height,
        borderRadius: circle ? '9999px' : radius || 'var(--ds-radius-sm)',
        ...style,
      }}
      aria-hidden="true"
    />
  );
}

function SkeletonText({ lines = 3, lastLineWidth = '60%' }) {
  return (
    <div className="ds-skeleton-text">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height={12} width={i === lines - 1 ? lastLineWidth : '100%'} />
      ))}
    </div>
  );
}

Skeleton.Text = SkeletonText;

export default Skeleton;
